import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "@studio-freight/lenis";
import { CartProvider } from "@/context/CartContext";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import CartDrawer from "@/components/CartDrawer";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import LookbookPage from "@/pages/LookbookPage";
import AboutPage from "@/pages/AboutPage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import PaymentCancelPage from "@/pages/PaymentCancelPage";

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <LanguageProvider>
        <CartProvider>
            <div className="grain-overlay" aria-hidden="true" />
            <BrowserRouter>
                <Navbar />
                <CartDrawer />
                <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/shop" element={<ShopPage />} />
                    <Route path="/prodotto/:id" element={<ProductPage />} />
                    <Route path="/lookbook" element={<LookbookPage />} />
                    <Route path="/about" element={<AboutPage />} />
                    <Route path="/payment/success" element={<PaymentSuccessPage />} />
                    <Route path="/payment/cancel" element={<PaymentCancelPage />} />
                </Routes>
                <Footer />
                <Toaster position="bottom-center" />
            </BrowserRouter>
        </CartProvider>
        </LanguageProvider>
    );
}

export default App;
